import { TextField, TextFieldProps } from "@mui/material";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";

interface IProps {
	value: any;
	setValue?(value: any): void;
	updateValue?(value: any): void;
	keyValue: string;

	inputProps?: TextFieldProps;
	className?: string;
	label?: string;
	disabled?: boolean;
}

const DataDateTime = (props: IProps) => {
	const [value, setValue] = useState<Date | null>(null);

	useEffect(() => {
		if (
			props.value &&
			props.keyValue in props.value &&
			props.value[props.keyValue] !== null
		) {
			setValue(new Date(props.value[props.keyValue] * 1000));
		} else {
			setValue(null);
		}
	}, [props.keyValue, props.value]);

	return (
		<DesktopDateTimePicker
			label={props.label || ""}
			className={props.className || ""}
			value={value}
			disabled={props.disabled}
			onChange={(val) => {
				if (val) {
					setValue(val);
				}
			}}
			onAccept={(val) => {
				if (props.setValue) {
					var eventValue = props.value;
					eventValue[props.keyValue] = Number(val) / 1000;
					props.setValue({ ...eventValue });
				}
				props.updateValue?.(Number(val) / 1000);
			}}
			renderInput={(params) => (
				<TextField
					onKeyUp={(e) => {
						if (e.key === "Enter") {
							if (props.setValue) {
								var eventValue = props.value;
								eventValue[props.keyValue] = Number(value) / 1000;
								props.setValue({ ...eventValue });
							}
							props.updateValue?.(Number(value) / 1000);
						}
					}}
					{...params}
					{...props.inputProps}
				/>
			)}
		/>
	);
};

export default DataDateTime;
